$(document).ready(function() {
	function toggleCheckoutButton() {
		const $checkbox = $('#accept-final-sale');
		const $checkoutButton = $('button.checkout, button.checkout-button');
		$checkoutButton.removeAttr('disabled');
		if(! document.querySelector('.hidden-additional-checkout-buttons')) {
			$('.cart__dynamic-checkout-buttons.additional-checkout-buttons').append('<div class="hidden-additional-checkout-buttons"></div>')
		}

		if ($checkbox.length) {
			$checkoutButton.prop('disabled', !$checkbox.is(':checked'));
			if($checkbox.is(':checked')) {
				$('.hidden-additional-checkout-buttons').css('display', 'none');
			}else {
				$('.hidden-additional-checkout-buttons').css('display', 'block');
			}
			$checkbox.on('change', toggleCheckoutButton);

		} else {
			$checkoutButton.removeAttr('disabled');
			$('.hidden-additional-checkout-buttons').css('display', 'none');
		}

		
	}

	// Initial check
	toggleCheckoutButton();

	const observer = new MutationObserver(() => {
		toggleCheckoutButton();
	});

	observer.observe(document.body, { childList: true, subtree: true });

});